import { HttpClient } from '@angular/common/http';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, Puser, User, UserService } from '../../shared';
import { SWF } from '../../shared/models';


@Component({
  selector: 'app-toolkit',
  templateUrl: './toolkit.component.html',
  styleUrls: ['./toolkit.component.css']
})
export class ToolkittComponent extends FormSessionCanDeactivate {
  showloader: boolean = true;
  videourl: string;
  activityBoardPDF: { url: string; withCredentials: boolean; };
  modalRef: BsModalRef;
  videotoolkit: any;
  public data: Object;
  resp: any;
  PUser: Puser;
  CurrentUser: User;
  toolkit: any;
  generLtoolkit: any;
  pdfPath: string;
  OpenPDF: boolean;
  apiurl: any = environment.api_url;
  lib_base: any = environment.lib_base;
  documenturl: string = environment.documenturl;
  @ViewChild('videoPlayer') videoplayer: any;
  SWF: SWF;
  type = 'toolkit';
  clientType: string;
  clientId: any;
  toolkitCNdocument: any;
  public imageURL: string;
  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService,
    private modalService: BsModalService,
  ) {


    super();
    //console.log("Patid", window.localStorage['patid']  )
    if (window.localStorage['patid']) {
      window.localStorage.removeItem('patid')
    }

    //console.log("patientId", window.localStorage['patientId']  )
    if (window.localStorage['patientId']) {
      window.localStorage.removeItem('patientId')
    }

  }




  ngOnInit() {
    this.OpenPDF = false;
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        if (this.CurrentUser.item) {
          this.clientId = this.CurrentUser.item.userAccountKey;
          this.clientType = this.CurrentUser.item.clientType;
        }
      }
    )
    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.documenturl;


    this.userService.getbulletinboard(this.type)
      .subscribe(
        data => {
          this.toolkit = data;
          ////console.log( this.toolkit, 'bulletinboard');

        }

      );
    this.activityBoardPDF = {
      url: this.documenturl + window.localStorage['pdfPath'],
      withCredentials: true
    }
    this.getGeneralDocument();
    this.getToolkitCNDocument(this.clientId, this.clientType);
  }

  getGeneralDocument() {
    this.userService.getGeneralDocument()
      .subscribe(
        data => {
          this.generLtoolkit = data;
          ////console.log( data, "general") ;

        }

      );
  }


  getToolkitCNDocument(clientId, clientType) {
    this.userService.getToolkitCNDocument(clientId, clientType)
      .subscribe(
        data => {
          this.toolkitCNdocument = data;
          ////console.log( data, "toolkitCNdocument") ;

        }

      );
  }

  downloadFile(file, filename) {
    var resp = file.split(".")
    return this.http
      .get(file, {
        responseType: 'blob'

      })
      .map(res => {
        return {
          filename: filename + '.' + resp[3],
          data: res
        };
      })
      .subscribe(res => {
        //////console.log('start download:',res);
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
        //////console.log('download error:', JSON.stringify(error));
      }, () => {
        //////console.log('Completed file download.')
      });
  }
  video(template12: TemplateRef<any>, video) {

    this.modalRef = this.modalService.show(template12, {
      backdrop: 'static'
    });
    this.movable()
    this.videotoolkit = video;


    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.videourl = environment.cloudeImageURL;
    else
      this.videourl = environment.documenturl;
  }
  pauseOrPlay(video) {
    video.pause();
    video.currentTime = 0;
    this.modalRef.hide();
  }

  getPdf(tool) {
    if (tool.filePath) {
      this.pdfPath = tool.filePath;
    }
    if (tool.docUrl) {
      this.pdfPath = tool.docUrl;
    }
    this.showloader = true
    this.OpenPDF = true;
  }

  callBackFn(pdf: PDFDocumentProxy) {
    this.showloader = false
  }
  back() {
    this.showloader = true
    this.OpenPDF = false;
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
}
